import React from "react";
//outsource
import { DatePicker } from "antd";

//components

//redux
import { useDispatch, useSelector } from "react-redux";
import { setFrom } from "../../../../store/report/report.action";
import { from, to } from "../../../../store/report/report.selector";

const formatDate = "DD/MM/YYYY";

const TimeFrom = ({ disabled }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------

  // -------------------------- REDUX --------------------------
  const dispatch = useDispatch();
  const dataFrom = useSelector(from);
  const dataTo = useSelector(to);
  // -------------------------- FUNCTION ------------------------
  const handleChange = (from) => {
    dispatch(setFrom({ data: from }));
  };
  // -------------------------- EFFECT --------------------------

  // -------------------------- RENDER --------------------------

  // -------------------------- MAIN --------------------------
  return (
    <DatePicker
      defaultValue={dataFrom}
      disabledDate={(current) => {
        return current && current >= dataTo;
      }}
      style={{ width: "100%" }}
      placeholder="From Date"
      format={formatDate}
      disabled={disabled}
      onChange={handleChange}
      allowClear={false}
    />
  );
};

export default TimeFrom;
